<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
              <Form-item label="登录账户" prop="account">
                <Input type="text" v-model="searchForm.account" placeholder="请输入登录账户" clearable
                       style="width: 200px"/>
              </Form-item>
              <Form-item label="实名名称" prop="name">
                <Input type="text" v-model="searchForm.name" placeholder="请输入实名名称" clearable
                       style="width: 200px"/>
              </Form-item>
              <Form-item label="ID" prop="id">
                <Input type="text" v-model="searchForm.id" placeholder="请输入id" clearable
                       style="width: 200px"/>
              </Form-item>
              <Form-item label="手机" prop="mobilePhone">
                <Input type="text" v-model="searchForm.mobilePhone" placeholder="请输入手机" clearable
                       style="width: 200px"/>
              </Form-item>
              <Form-item label="邮箱" prop="email">
                <Input type="text" v-model="searchForm.email" placeholder="请输入邮箱" clearable
                       style="width: 200px"/>
              </Form-item>
              <Form-item label="账户类型" prop="accountType">
                <Select v-model="searchForm.accountType" style="width: 200px">
                  <Option value="">全部</Option>
                  <Option value="person">个人</Option>
                  <Option value="enterprise">企业</Option>
                </Select>
                <!--<Input type="text" v-model="searchForm.accountType"
                       placeholder="请输入账户类型:enterprise：企业,person：个人" clearable style="width: 200px"/>-->
              </Form-item>
              <Form-item label="实名状态" prop="realNameStatus">
                <Select v-model="searchForm.realNameStatus" style="width: 200px">
                  <Option value="">全部</Option>
                  <Option value="un_real_name">未实名</Option>
                  <Option value="wait_certificate">待上传实名证件</Option>
                  <Option value="wait_approve">待实名审核</Option>
                  <Option value="complete_real_name">已实名</Option>
                  <Option value="reject_real_name">实名驳回</Option>
                </Select>
                <!--<Input type="text" v-model="searchForm.realNameStatus"
                       placeholder="请输入实名状态  un_real_name：未实名     wait_certificate：待上传实名证件    wait_approve：待实名审核     complete_real_name：已实名   reject_real_name：实名驳回"
                       clearable style="width: 200px"/>-->
              </Form-item>
              <Form-item label="来源" prop="copyrightType">
                <Select v-model="searchForm.activityId" placeholder="请选择" clearable style="width: 200px">
                  <Option value="">全部</Option>
                  <Option v-for="(item, i) in activities" :key="i" :value="item.id">
                    {{item.name}}</Option>
                </Select>
                <!-- <Input type="text" v-model="searchForm.copyrightType" placeholder="请输入所属类型" clearable style="width: 200px"/> -->
              </Form-item>
              <span v-if="drop">
                <!--<Form-item label="用户自定义昵称（也可能是第三方平台 微信 微博 qq昵称）" prop="nickName">
                  <Input type="text" v-model="searchForm.nickName" placeholder="请输入用户自定义昵称（也可能是第三方平台 微信 微博 qq昵称）"
                         clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="实名后的名称" prop="name">
                  <Input type="text" v-model="searchForm.name" placeholder="请输入实名后的名称" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="身份证号" prop="idCardNoEncrypt">
                  <Input type="text" v-model="searchForm.idCardNoEncrypt" placeholder="请输入身份证号" clearable
                         style="width: 200px"/>
                </Form-item>
                <Form-item label="密码，md5 加密。" prop="password">
                  <Input type="text" v-model="searchForm.password" placeholder="请输入密码，md5 加密。" clearable
                         style="width: 200px"/>
                </Form-item>
                <Form-item label="联系邮箱" prop="email">
                  <Input type="text" v-model="searchForm.email" placeholder="请输入联系邮箱" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="Email绑定状态 0 未绑定  1 绑定" prop="emailBindStatus">
                  <Input type="text" v-model="searchForm.emailBindStatus" placeholder="请输入Email绑定状态 0 未绑定  1 绑定"
                         clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="手机号" prop="mobilePhoneEncrypt">
                  <Input type="text" v-model="searchForm.mobilePhoneEncrypt" placeholder="请输入手机号" clearable
                         style="width: 200px"/>
                </Form-item>
                <Form-item label="手机号绑定状态" prop="mobileBindStatus">
                  <Input type="text" v-model="searchForm.mobileBindStatus" placeholder="请输入手机号绑定状态" clearable
                         style="width: 200px"/>
                </Form-item>
                <Form-item
                  label="实名状态  un_real_name：未实名     wait_certificate：待上传实名证件    wait_approve：待实名审核     complete_real_name：已实名   reject_real_name：实名驳回"
                  prop="realNameStatus">
                  <Input type="text" v-model="searchForm.realNameStatus"
                         placeholder="请输入实名状态  un_real_name：未实名     wait_certificate：待上传实名证件    wait_approve：待实名审核     complete_real_name：已实名   reject_real_name：实名驳回"
                         clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="联系电话，这个通常说的是座机。" prop="phone">
                  <Input type="text" v-model="searchForm.phone" placeholder="请输入联系电话，这个通常说的是座机。" clearable
                         style="width: 200px"/>
                </Form-item>
                <Form-item label="登记人头像" prop="photo">
                  <Input type="text" v-model="searchForm.photo" placeholder="请输入登记人头像" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="联系地址" prop="address">
                  <Input type="text" v-model="searchForm.address" placeholder="请输入联系地址" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="邮政编码" prop="zipCode">
                  <Input type="text" v-model="searchForm.zipCode" placeholder="请输入邮政编码" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="联系人传真" prop="fax">
                  <Input type="text" v-model="searchForm.fax" placeholder="请输入联系人传真" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="传真" prop="areaCode">
                  <Input type="text" v-model="searchForm.areaCode" placeholder="请输入传真" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="注册时间" prop="regTime">
                  <DatePicker v-model="selectDate" type="daterange" format="yyyy-MM-dd" clearable
                              @on-change="selectDateRange" placeholder`="选择起始时间" style="width: 200px"></DatePicker>
                </Form-item>
                <Form-item label="注册来源终端:pc,android,ios,weixin" prop="regTerminal">
                  <Input type="text" v-model="searchForm.regTerminal" placeholder="请输入注册来源终端:pc,android,ios,weixin"
                         clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="备注" prop="remark">
                  <Input type="text" v-model="searchForm.remark" placeholder="请输入备注" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="来源平台，大部分是开放平台的app_id,有其他的一些未知渠道，什么360，baidu,migu_misic 遗留数据尚不清楚。"
                           prop="platformSource">
                  <Input type="text" v-model="searchForm.platformSource"
                         placeholder="请输入来源平台，大部分是开放平台的app_id,有其他的一些未知渠道，什么360，baidu,migu_misic 遗留数据尚不清楚。" clearable
                         style="width: 200px"/>
                </Form-item>
                <Form-item label="来源系统:banquanjia：“版权家”，bqjClientEditionMac : 版权家  bqjClientEditionWin" prop="appName">
                  <Input type="text" v-model="searchForm.appName"
                         placeholder="请输入来源系统:banquanjia：“版权家”，bqjClientEditionMac : 版权家  bqjClientEditionWin" clearable
                         style="width: 200px"/>
                </Form-item>
                <Form-item label="是否可登录 0 不可登录 1 可正常登录" prop="loginFlag">
                  <Input type="text" v-model="searchForm.loginFlag" placeholder="请输入是否可登录 0 不可登录 1 可正常登录" clearable
                         style="width: 200px"/>
                </Form-item>
                <Form-item label="原创签名" prop="originalSignature">
                  <Input type="text" v-model="searchForm.originalSignature" placeholder="请输入原创签名" clearable
                         style="width: 200px"/>
                </Form-item>
                <Form-item label="备注信息" prop="remarks">
                  <Input type="text" v-model="searchForm.remarks" placeholder="请输入备注信息" clearable style="width: 200px"/>
                </Form-item>-->
              </span>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
                <a class="drop-down" @click="dropDown">
                  {{dropDownContent}}
                  <Icon :type="dropDownIcon"></Icon>
                </a>
              </Form-item>
            </Form>
          </Row>
          <!--<Row class="operation">
            <Button @click="add" type="primary" icon="md-add">添加</Button>
            <Button @click="delAll" icon="md-trash">批量删除</Button>
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
          </Row>-->
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom"
                   @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize"
                  @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]"
                  size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>

    <Drawer width="640" v-model="infoDrawerVisible" title="实名审核">
      <div slot="header">
        <Row>
          <Col>
            <span>实名审核</span>
          </Col>
        </Row>
        <Row type="flex" justify="space-around">
            <Button type="error" :loading="submitLoading" @click="auditRealNameSubmit('0')">审核拒绝</Button>
            <Button type="primary" :loading="submitLoading" @click="auditRealNameSubmit('1')">审核通过</Button>
            <Button type="primary" :loading="submitLoading" @click="auditPowerUser()">保存修改</Button>
        </Row>
      </div>
      <Form ref="infoForm" :model="infoForm" :label-width="100" :rules="formValidate" >
        <FormItem label="用户姓名" prop="name" >
          <Input v-model="infoForm.name" style="width:100%"/>
        </FormItem>
        <FormItem label="笔名、简称" prop="nickName" >
          <Input v-model="infoForm.nickName" style="width:100%"/>
        </FormItem>
        <FormItem label="认证方式" prop="authMethod">
          <!--<Input v-model="infoForm.authMethod" style="width:100%"/>-->
          <Select v-model="infoForm.authMethod">
            <Option :value=>未知</Option>
            <Option value="idcard">身份证</Option>
            <Option value="mainland_passport">大陆护照</Option>
            <Option value="mainland_officer">大陆军官证</Option>
            <Option value="mainland_police">大陆警官证</Option>
            <Option value="hongkong">香港</Option>
            <Option value="macao">澳门</Option>
            <Option value="taiwan">台湾</Option>
            <Option value="foreign">外籍</Option>
            <Option value="enterprise">企业</Option>
          </Select>
        </FormItem>
        <FormItem label="权利人类型" prop="obligeeType" >
          <!--<Input v-model="infoForm.obligeeType" style="width:100%"/>-->
          <Select v-model="infoForm.obligeeType">
            <Option value="">未知</Option>
            <Option value="person">个人</Option>
            <Option value="enterprise">企业</Option>
          </Select>
        </FormItem>
        <FormItem label="证件类型" prop="identityType" >
          <!--<Input v-model="infoForm.identityType" style="width:100%"/>-->
          <Select v-model="infoForm.identityType">
            <Option value="">未知</Option>
            <Option value="1">身份证</Option>
            <Option value="2">护照</Option>
            <Option value="3">军官证</Option>
            <Option value="4">企业法人营业执照</Option>
            <Option value="5">组织机构代码证书</Option>
            <Option value="6">事业单位法人证书</Option>
            <Option value="7">7社团法人证书</Option>
            <Option value="8">警官证</Option>
            <Option value="9">其他类型</Option>
          </Select>
        </FormItem>
        <FormItem label="证件号码" prop="identityNo" >
          <Input v-model="infoForm.identityNumber" style="width:100%"/>
        </FormItem>
        <!--<FormItem label="证件号加密" prop="identityNoEncrypt" >
          <Input v-model="infoForm.identityNoEncrypt" style="width:100%"/>
        </FormItem>-->
        <FormItem label="国家" prop="country" >
          <Input v-model="infoForm.country" style="width:100%"/>
        </FormItem>
        <FormItem label="省份" prop="province" >
          <Input v-model="infoForm.province" style="width:100%"/>
        </FormItem>
        <FormItem label="城市" prop="city" >
          <Input v-model="infoForm.city" style="width:100%"/>
        </FormItem>
        <FormItem label="联系人" prop="signature" >
          <Input v-model="infoForm.signature" style="width:100%"/>
        </FormItem>
        <FormItem label="登记人ID" prop="registerId" >
          <Input v-model="infoForm.registerId" style="width:100%"/>
        </FormItem>
        <FormItem label="证件扫描件1" prop="attachment1" v-if="infoForm.obligeeType == 'person'">
          <!--<Input v-model="infoForm.attachment1" style="width:100%"/>-->
          <!--<img v-bind:src="obsPrefix+infoForm.attachment1" @click="showPic" style="width: 300px; height: 150px"/>-->
          <img v-bind:src="infoForm.attachment1Url" @click="showPic" style="width: 300px; height: 150px"/>
        </FormItem>
        <!--<FormItem label="" prop="attachment1Uuid" >
          <Input v-model="infoForm.attachment1Uuid" style="width:100%"/>
        </FormItem>-->
        <FormItem label="证件扫描件2" prop="attachment2" v-if="infoForm.obligeeType == 'person'">
          <!--<Input v-model="infoForm.attachment2" style="width:100%"/>-->
          <!--<img v-bind:src="obsPrefix+infoForm.attachment2" @click="showPic" style="width: 300px; height: 150px"/>-->
          <img v-bind:src="infoForm.attachment2Url" @click="showPic" style="width: 300px; height: 150px"/>
        </FormItem>
        <!--<FormItem label="" prop="attachment2Uuid" >
          <Input v-model="infoForm.attachment2Uuid" style="width:100%"/>
        </FormItem>-->
        <FormItem label="证件扫描件3" prop="attachment3" v-if="infoForm.obligeeType == 'enterprise'">
          <!--<Input v-model="infoForm.attachment3" style="width:100%"/>-->
          <!--<img v-bind:src="obsPrefix+infoForm.attachment3" @click="showPic" style="width: 300px; height: 150px"/>-->
          <img v-bind:src="infoForm.attachment3Url" @click="showPic" style="width: 300px; height: 150px"/>
        </FormItem>
        <!--<FormItem label="" prop="attachment3Uuid" >
          <Input v-model="infoForm.attachment3Uuid" style="width:100%"/>
        </FormItem>-->
        <FormItem label="证件扫描件4" prop="attachment4" v-if="infoForm.obligeeType == 'enterprise'">
          <!--<Input v-model="infoForm.attachment4" style="width:100%"/>-->
          <!--<img v-bind:src="obsPrefix+infoForm.attachment4" @click="showPic" style="width: 300px; height: 150px"/>-->
          <img v-bind:src="infoForm.attachment4Url" @click="showPic" style="width: 300px; height: 150px"/>
        </FormItem>
        <FormItem label="证件扫描件5" prop="attachment5" v-if="infoForm.obligeeType == 'enterprise'">
          <!--<Input v-model="infoForm.attachment5" style="width:100%"/>-->
          <!--<img v-bind:src="obsPrefix+infoForm.attachment5" @click="showPic" style="width: 300px; height: 150px"/>-->
          <img v-bind:src="infoForm.attachment5Url" @click="showPic" style="width: 300px; height: 150px"/>
        </FormItem>
        <FormItem label="证件有效期开始时间" prop="attachStartTime" >
          <Input v-model="infoForm.attachStartTime" style="width:100%"/>
        </FormItem>
        <FormItem label="证件有效期结束时间" prop="attachEndTime" >
          <Input v-model="infoForm.attachEndTime" style="width:100%"/>
        </FormItem>
        <FormItem label="创建时间" prop="createdAt" >
          <DatePicker type="date" v-model="infoForm.createdAt" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="是否是主要权利人" prop="isRegister" >
          <!--<Input v-model="infoForm.isRegister" style="width:100%"/>-->
          <Select v-model="infoForm.isRegister">
            <Option :value=>未知</Option>
            <Option :value=0>不是</Option>
            <Option :value=1>是</Option>
          </Select>
        </FormItem>
        <FormItem label="地址" prop="address" >
          <Input v-model="infoForm.address" style="width:100%"/>
        </FormItem>
        <FormItem label="权利人实名状态" prop="obligeeRealNameStatus" >
          <!--<Input v-model="infoForm.obligeeRealNameStatus" style="width:100%"/>-->
          <Select v-model="infoForm.obligeeRealNameStatus">
            <Option value="">未知</Option>
            <Option value="1">待提交证件</Option>
            <Option value="2">已完成实名</Option>
            <Option value="3">实名驳回</Option>
          </Select>
        </FormItem>
        <FormItem label="mobile" prop="mobilePhone" >
          <Input v-model="infoForm.mobilePhone" style="width:100%"/>
        </FormItem>
        <FormItem label="邮箱" prop="email" >
          <Input v-model="infoForm.email" style="width:100%"/>
        </FormItem>
        <FormItem v-if="infoForm.obligeeType == 'enterprise'" label="企业法人姓名" prop="legalName" >
          <Input v-model="infoForm.legalName" style="width:100%"/>
        </FormItem>
        <FormItem v-if="infoForm.obligeeType == 'enterprise'" label="企业法人身份证号" prop="legalIdentityNo" >
          <Input v-model="infoForm.legalIdentityNo" style="width:100%"/>
        </FormItem>
        <FormItem v-if="infoForm.obligeeType == 'enterprise'" label="法人证件图片正面" prop="legalPicCardOn" >
          <img v-bind:src="obsPrefix+infoForm.legalPicCardOn" @click="showPic" style="width: 300px; height: 150px"/>
          <!--<Input v-model="infoForm.legalPicCardOn" style="width:100%"/>-->
        </FormItem>
        <FormItem v-if="infoForm.obligeeType == 'enterprise'" label="法人证件图片反面" prop="legalPicCardBack" >
          <img v-bind:src="obsPrefix+infoForm.legalPicCardBack" @click="showPic" style="width: 300px; height: 150px"/>
          <!--<Input v-model="infoForm.legalPicCardBack" style="width:100%"/>-->
        </FormItem>
        <FormItem v-if="infoForm.obligeeType == 'enterprise'" label="法人证件有效期开始时间" prop="legalStartTime" >
          <Input v-model="infoForm.legalStartTime" style="width:100%"/>
        </FormItem>
        <FormItem v-if="infoForm.obligeeType == 'enterprise'" label="法人证件有效期结束时间" prop="legalEndTime" >
          <Input v-model="infoForm.legalEndTime" style="width:100%"/>
        </FormItem>
        <FormItem v-if="infoForm.obligeeType == 'enterprise'" label="法人实名认证状态" prop="legalStatus" >
          <Input v-model="infoForm.legalStatus" style="width:100%"/>
        </FormItem>
        <FormItem v-if="infoForm.obligeeType == 'enterprise'" label="法人实名认证原因" prop="legalVerifyReason" >
          <Input v-model="infoForm.legalVerifyReason" style="width:100%"/>
        </FormItem>
        <FormItem label="是否修改过(0:未修改，1：修改)" prop="legalModifyFlag" >
          <Input v-model="infoForm.legalModifyFlag" style="width:100%"/>
        </FormItem>
        <FormItem label="权利人是否修改过(0:未修改，1：修改)" prop="modifyFlag" >
          <Input v-model="infoForm.modifyFlag" style="width:100%"/>
        </FormItem>
        <FormItem label="入境证明URL" prop="enterCertify" >
          <Input v-model="infoForm.enterCertify" style="width:100%"/>
        </FormItem>
        <FormItem label="人工审核状态" prop="artificialAuditStatus" >
          <!--<Input v-model="infoForm.artificialAuditStatus" style="width:100%"/>-->
          <Select v-model="infoForm.artificialAuditStatus">
            <Option value="">未知</Option>
            <Option value="wait_real_name_audit">待审核</Option>
            <Option value="complete_real_name_audit">审核通过</Option>
            <Option value="reject_real_name">审核驳回</Option>
          </Select>
        </FormItem>
        <FormItem label="人工审核状态变化时间" prop="auditStatusTime" >
          <DatePicker type="date" v-model="infoForm.auditStatusTime" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="银行预留手机号" prop="cardPhone" >
          <Input v-model="infoForm.cardPhone" style="width:100%"/>
        </FormItem>
        <FormItem label="银行卡号" prop="cardNo" >
          <Input v-model="infoForm.cardNo" style="width:100%"/>
        </FormItem>
        <FormItem label="备注信息" prop="remarks" >
          <Input v-model="infoForm.remarks" style="width:100%"/>
        </FormItem>
      </Form>
    </Drawer>

    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate">
        <FormItem label="登录账户" prop="account">
          <Input v-model="form.account" style="width:100%"/>
        </FormItem>
        <FormItem label="账户类型:enterprise：企业,person：个人" prop="accountType">
          <Input v-model="form.accountType" style="width:100%"/>
        </FormItem>
        <FormItem label="用户自定义昵称（也可能是第三方平台 微信 微博 qq昵称）" prop="nickName">
          <Input v-model="form.nickName" style="width:100%"/>
        </FormItem>
        <FormItem label="实名后的名称" prop="name">
          <Input v-model="form.name" style="width:100%"/>
        </FormItem>
        <FormItem label="身份证号" prop="idCardNoEncrypt">
          <Input v-model="form.idCardNoEncrypt" style="width:100%"/>
        </FormItem>
        <FormItem label="密码，md5 加密。" prop="password">
          <Input v-model="form.password" style="width:100%"/>
        </FormItem>
        <FormItem label="联系邮箱" prop="email">
          <Input v-model="form.email" style="width:100%"/>
        </FormItem>
        <FormItem label="Email绑定状态 0 未绑定  1 绑定" prop="emailBindStatus">
          <Input v-model="form.emailBindStatus" style="width:100%"/>
        </FormItem>
        <FormItem label="手机号" prop="mobilePhoneEncrypt">
          <Input v-model="form.mobilePhoneEncrypt" style="width:100%"/>
        </FormItem>
        <FormItem label="手机号绑定状态" prop="mobileBindStatus">
          <Input v-model="form.mobileBindStatus" style="width:100%"/>
        </FormItem>
        <FormItem
          label="实名状态  un_real_name：未实名     wait_certificate：待上传实名证件    wait_approve：待实名审核     complete_real_name：已实名   reject_real_name：实名驳回"
          prop="realNameStatus">
          <Input v-model="form.realNameStatus" style="width:100%"/>
        </FormItem>
        <FormItem label="联系电话，这个通常说的是座机。" prop="phone">
          <Input v-model="form.phone" style="width:100%"/>
        </FormItem>
        <FormItem label="登记人头像" prop="photo">
          <Input v-model="form.photo" style="width:100%"/>
        </FormItem>
        <FormItem label="联系地址" prop="address">
          <Input v-model="form.address" style="width:100%"/>
        </FormItem>
        <FormItem label="邮政编码" prop="zipCode">
          <Input v-model="form.zipCode" style="width:100%"/>
        </FormItem>
        <FormItem label="联系人传真" prop="fax">
          <Input v-model="form.fax" style="width:100%"/>
        </FormItem>
        <FormItem label="传真" prop="areaCode">
          <Input v-model="form.areaCode" style="width:100%"/>
        </FormItem>
        <FormItem label="注册时间" prop="regTime">
          <DatePicker type="date" v-model="form.regTime" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="注册来源终端:pc,android,ios,weixin" prop="regTerminal">
          <Input v-model="form.regTerminal" style="width:100%"/>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="form.remark" style="width:100%"/>
        </FormItem>
        <FormItem label="来源平台，大部分是开放平台的app_id,有其他的一些未知渠道，什么360，baidu,migu_misic 遗留数据尚不清楚。"
                  prop="platformSource">
          <Input v-model="form.platformSource" style="width:100%"/>
        </FormItem>
        <FormItem label="来源系统:banquanjia：“版权家”，bqjClientEditionMac : 版权家  bqjClientEditionWin" prop="appName">
          <Input v-model="form.appName" style="width:100%"/>
        </FormItem>
        <FormItem label="是否可登录 0 不可登录 1 可正常登录" prop="loginFlag">
          <Input v-model="form.loginFlag" style="width:100%"/>
        </FormItem>
        <FormItem label="原创签名" prop="originalSignature">
          <Input v-model="form.originalSignature" style="width:100%"/>
        </FormItem>
        <FormItem label="备注信息" prop="remarks">
          <Input v-model="form.remarks" style="width:100%"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit">提交</Button>
      </div>
    </Modal>

    <Modal v-model="picVisible" title="图片预览" footer-hide draggable>
      <img :src="infoForm.avatar" alt="无效的图片链接" style="width: 100%;margin: 0 auto;display: block;">
    </Modal>
    <Modal v-model="showRejectModal" title="驳回原因" footer-hide draggable>
      <Row type="flex" justify="space-around">
        <Col span="12">
          <Input placeholder="拒绝原因" v-model="auditMsg"/>
        </Col>
        <Col offset="4" span="4">
          <Button type="default" @click="showRejectModal=false">取消</Button>
        </Col>
        <Col span="4">
          <Button type="primary" :loading="submitLoading" @click="rejectSubmit">提交</Button>
        </Col>
      </Row>
    </Modal>

    <Modal :title="giftTitle" v-model="giftVisible" :mask-closable='false' :width="500">
      <Form ref="giftForm" :model="giftForm" :label-width="100" :rules="formValidate">
        <FormItem label="登录账户" prop="account">
          <Input v-model="giftForm.account" style="width:100%"/>
        </FormItem>
        <FormItem label="账户类型:enterprise：企业,person：个人" prop="accountType">
          <Input v-model="giftForm.accountType" style="width:100%"/>
        </FormItem>
        <FormItem label="用户自定义昵称（也可能是第三方平台 微信 微博 qq昵称）" prop="nickName">
          <Input v-model="giftForm.nickName" style="width:100%"/>
        </FormItem>
        <FormItem label="实名后的名称" prop="name">
          <Input v-model="giftForm.name" style="width:100%"/>
        </FormItem>
        <FormItem label="身份证号" prop="idCardNoEncrypt">
          <Input v-model="giftForm.idCardNoEncrypt" style="width:100%"/>
        </FormItem>
        <Form-item label="赠送VIP" prop="accountType">
          <Select v-model="giftForm.gift" style="width: 200px">
            <Option
              v-for="item in giftForm.gift"
              :value="item.code"
            >{{ item.title }}</Option>
          </Select>
        </Form-item>
      </Form>
      <div slot="footer">
        <Button type="text" @click="giftVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="giftSubmit">提交</Button>
      </div>
    </Modal>

    <Modal :title="giftRedenvelopeTitle" v-model="giftRedenvelopeVisible" :mask-closable='false' :width="500">
      <Form ref="giftRedenvelopeForm" :model="giftRedenvelopeForm" :label-width="100" :rules="formValidate">
        <FormItem label="登录账户" prop="account">
          <Input v-model="giftRedenvelopeForm.account" style="width:100%"/>
        </FormItem>
        <FormItem label="账户类型:enterprise：企业,person：个人" prop="accountType">
          <Input v-model="giftRedenvelopeForm.accountType" style="width:100%"/>
        </FormItem>
        <FormItem label="用户自定义昵称（也可能是第三方平台 微信 微博 qq昵称）" prop="nickName">
          <Input v-model="giftRedenvelopeForm.nickName" style="width:100%"/>
        </FormItem>
        <FormItem label="实名后的名称" prop="name">
          <Input v-model="giftRedenvelopeForm.name" style="width:100%"/>
        </FormItem>
        <FormItem label="身份证号" prop="idCardNoEncrypt">
          <Input v-model="giftRedenvelopeForm.idCardNoEncrypt" style="width:100%"/>
        </FormItem>
        <Form-item label="赠送红包金额/元" prop="accountType">
          <Input v-model="giftRedenvelopeForm.amount" style="width: 100%" type="number"/>
        </Form-item>
      </Form>
      <div slot="footer">
        <Button type="text" @click="giftRedenvelopeVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="giftRedenvelopeSubmit">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  import Expand from './Expand';
  export default {
    name: "Register",
    components: {
      Expand
    },
    data() {
      return {
        activities: [],
        auditMsg: '',
        showRejectModal: false,
        picVisible: false,
        obsPrefix: 'http://anne-bqj-file.obs.cn-north-4.myhuaweicloud.com/',
        infoDrawerVisible: false, // 信息查看
        loading: true, // 表单加载状态
        modalType: 0, // 添加或编辑标识
        modalVisible: false, // 添加或编辑显示
        modalTitle: "", // 添加或编辑标题
        giftTitle: "赠送VIP", //
        giftVisible: false, //
        giftForm: {
          account: "",
          accountType: "",
          nickName: "",
          name: "",
          idCardNoEncrypt: "",
          password: "",
          email: "",
          emailBindStatus: "",
          mobilePhoneEncrypt: "",
          mobileBindStatus: "",
          realNameStatus: "",
          phone: "",
          photo: "",
          address: "",
          zipCode: "",
          fax: "",
          areaCode: "",
          regTime: "",
          regTerminal: "",
          remark: "",
          platformSource: "",
          appName: "",
          loginFlag: "",
          originalSignature: "",
          remarks: "",
          gift:[]
        }, //
        giftRedenvelopeTitle: "赠送红包", //
        giftRedenvelopeVisible: false, //
        giftRedenvelopeForm: {
          account: "",
          accountType: "",
          nickName: "",
          name: "",
          idCardNoEncrypt: "",
          password: "",
          email: "",
          emailBindStatus: "",
          mobilePhoneEncrypt: "",
          mobileBindStatus: "",
          realNameStatus: "",
          phone: "",
          photo: "",
          address: "",
          zipCode: "",
          fax: "",
          areaCode: "",
          regTime: "",
          regTerminal: "",
          remark: "",
          platformSource: "",
          appName: "",
          loginFlag: "",
          originalSignature: "",
          remarks: "",
          amount: 0,
        }, //
        drop: false,
        dropDownContent: "展开",
        dropDownIcon: "ios-arrow-down",
        searchForm: { // 搜索框初始化对象
          pageNumber: 1, // 当前页数
          pageSize: 10, // 页面大小
          sort: "createDate", // 默认排序字段
          order: "desc", // 默认排序方式
          startDate: "", // 起始时间
          endDate: "" // 终止时间
        },
        selectDate: null,
        form: { // 添加或编辑表单对象初始化数据
          account: "",
          accountType: "",
          nickName: "",
          name: "",
          idCardNoEncrypt: "",
          password: "",
          email: "",
          emailBindStatus: "",
          mobilePhoneEncrypt: "",
          mobileBindStatus: "",
          realNameStatus: "",
          phone: "",
          photo: "",
          address: "",
          zipCode: "",
          fax: "",
          areaCode: "",
          regTime: "",
          regTerminal: "",
          remark: "",
          platformSource: "",
          appName: "",
          loginFlag: "",
          originalSignature: "",
          remarks: "",
        },
        // 表单验证规则
        formValidate: {},
        submitLoading: false, // 添加或编辑提交状态
        selectList: [], // 多选数据
        selectCount: 0, // 多选计数
        columns: [
          // 表头
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            type: "expand",
            width: 60,
            align: "center",
            render(h, params){
              return h(Expand, {
                props: {
                  expandData: params.row
                }
              });
            }
          },
          {
            title: "ID",
            key: "id",
            minWidth: 80,
            sortable: false,
          },
          {
            title: "登录账户",
            key: "account",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "账户类型",
            key: "accountType",
            minWidth: 120,
            sortable: false,
            render(h, params){
              return h('span', params.row.accountType === 'person' ? '个人' : params.row.accountType === 'enterprise' ? '企业' : '未知');
            }
          },
          {
            title: "用户昵称",
            key: "nickName",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "实名",
            key: "name",
            minWidth: 120,
            sortable: false,
          },
          /*{
            title: "身份证号",
            key: "idCardNoEncrypt",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "密码，md5 加密。",
            key: "password",
            minWidth: 120,
            sortable: false,
          },*/
          {
            title: "联系邮箱",
            key: "email",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "手机号",
            key: "mobilePhone",
            minWidth: 120,
            sortable: false,
          },
          /*{
            title: "Email绑定状态",
            key: "emailBindStatus",
            minWidth: 120,
            sortable: false,
            render(h, params){
              return h('span', params.row.emailBindStatus == '0' ? '未绑定' : params.row.accountType == '1' ? '绑定' : '未知');
            }
          },
          {
            title: "手机号",
            key: "mobilePhoneEncrypt",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "手机号绑定状态",
            key: "mobileBindStatus",
            minWidth: 120,
            sortable: false,
          },*/
          {
            title: "实名状态",
            key: "realNameStatus",
            minWidth: 120,
            sortable: false,
            render(h, params){
              let state = '未知';
              switch(params.row.realNameStatus){
                case 'un_real_name':
                  state = '未实名';
                  break;
                case 'wait_certificate':
                  state = '待上传实名证件';
                  break;
                case 'wait_approve':
                  state = '待实名审核';
                  break;
                case 'complete_real_name':
                  state = '已实名';
                  break;
                case 'reject_real_name':
                  state = '实名驳回';
                  break;
              }
              return h('span', state);
            }
          },
          /*{
            title: "联系电话，这个通常说的是座机。",
            key: "phone",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "登记人头像",
            key: "photo",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "联系地址",
            key: "address",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "邮政编码",
            key: "zipCode",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "联系人传真",
            key: "fax",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "传真",
            key: "areaCode",
            minWidth: 120,
            sortable: false,
          },
          */
          {
            title: "注册时间",
            key: "regTime",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "VIP到期时间",
            key: "vipExpireTime",
            minWidth: 120,
            sortable: false,
            render(h, params){
              return h('span', params.row.registerVipMember.enddate);
            }
          },
          {
            title: "账户余额",
            key: "ewallet",
            minWidth: 120,
            sortable: false,
            render(h, params){
              return h('span', params.row.registerEwallet.amount/100);
            }
          },
          {
            title: "账户红包",
            key: "redEnvelope",
            minWidth: 120,
            sortable: false,
            render(h, params){
              return h('span', params.row.registerRedEnvelope.amount/100);
            }
          },
          {
            title: "来源(参与活动)",
            key: "activities",
            minWidth: 120,
            sortable: false,
            render(h, params){
              if(params.row.activityNames){
                return h('span', params.row.activityNames.join(','));
              }else{
                return h('span', '');
              }
            }
          },{
            title: "注册来源",
            key: "regTerminal",
            minWidth: 120,
            sortable: false,
          },
          /*{
            title: "备注",
            key: "remark",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "来源平台，大部分是开放平台的app_id,有其他的一些未知渠道，什么360，baidu,migu_misic 遗留数据尚不清楚。",
            key: "platformSource",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "来源系统:banquanjia：“版权家”，bqjClientEditionMac : 版权家  bqjClientEditionWin",
            key: "appName",
            minWidth: 120,
            sortable: false,
          },*/
          {
            title: "是否可登录",
            key: "loginFlag",
            minWidth: 120,
            sortable: false,
            render(h, params){
              return h('span', params.row.loginFlag == '0' ? '不可登录' : params.row.loginFlag == '1' ? '可正常登录' : '未知');
            }
          },
          {
            title: "原创签名",
            key: "originalSignature",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "备注信息",
            key: "remarks",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "更新时间",
            key: "updateDate",
            minWidth: 120,
            sortable: false,
          },
          {
            title: "操作",
            key: "action",
            align: "center",
            width: 300,
            fixed: "right",
            render: (h, params) => {
              if(params.row.realNameStatus == 'wait_approve' || params.row.realNameStatus == 'reject_real_name' || params.row.realNameStatus == 'wait_certificate'){
                return h("div", [
                  h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                        icon: "ios-create-outline"
                      },
                      style: {
                        marginRight: "5px"
                      },
                      on: {
                        click: () => {
                          this.auditRealName(params.row);
                        }
                      }
                    },
                    "实名审核"
                  )
                ]);
              }else if(params.row.realNameStatus == 'complete_real_name'){
                return h("div", [
                    /*h(
                        "Button",
                        {
                            props: {
                                type: "primary",
                                size: "small",
                                icon: "ios-create-outline"
                            },
                            style: {
                                marginRight: "5px"
                            },
                            on: {
                                click: () => {
                                    this.auditRealName(params.row);
                                }
                            }
                        },
                        "实名审核"
                    ),*/
                  h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                        icon: "ios-create-outline"
                      },
                      style: {
                        marginRight: "5px"
                      },
                      on: {
                        click: () => {
                          this.gift(params.row);
                        }
                      }
                    },
                    "赠送VIP"
                  ),
                  h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                        icon: "ios-create-outline"
                      },
                      style: {
                        marginRight: "5px"
                      },
                      on: {
                        click: () => {
                          this.giftRedenvelope(params.row);
                        }
                      }
                    },
                    "赠送红包"
                  ),
                ])
              }
            }
          }
        ],
        data: [], // 表单数据
        total: 0, // 表单数据总数
        infoForm: {}
      };
    },
    methods: {
      init() {
        // 带多条件搜索参数获取表单数据 请自行修改接口
        this.getRequest("/activity/getAll", {}).then(res => {
          if (res.success) {
            this.activities = res.result;
            this.getDataList();
          }
        });

      },
      changePage(v) {
        this.searchForm.pageNumber = v;
        this.getDataList();
        this.clearSelectAll();
      },
      changePageSize(v) {
        this.searchForm.pageSize = v;
        this.getDataList();
      },
      handleSearch() {
        console.log("handleSearch");
        this.searchForm.pageNumber = 1;
        this.searchForm.pageSize = 10;
        this.getDataList();
      },
      handleReset() {
        this.$refs.searchForm.resetFields();
        this.searchForm.pageNumber = 1;
        this.searchForm.pageSize = 10;
        this.selectDate = null;
        this.searchForm.activityId = '';
        this.searchForm.startDate = "";
        this.searchForm.endDate = "";
        // 重新加载数据
        this.getDataList();
      },
      changeSort(e) {
        this.searchForm.sort = e.key;
        this.searchForm.order = e.order;
        if (e.order === "normal") {
          this.searchForm.order = "";
        }
        this.getDataList();
      },
      clearSelectAll() {
        this.$refs.table.selectAll(false);
      },
      changeSelect(e) {
        this.selectList = e;
        this.selectCount = e.length;
      },
      selectDateRange(v) {
        if (v) {
          this.searchForm.startDate = v[0];
          this.searchForm.endDate = v[1];
        }
      },
      dropDown() {
        if (this.drop) {
          this.dropDownContent = "展开";
          this.dropDownIcon = "ios-arrow-down";
        } else {
          this.dropDownContent = "收起";
          this.dropDownIcon = "ios-arrow-up";
        }
        this.drop = !this.drop;
      },
      getDataList() {
        this.loading = true;
        // 带多条件搜索参数获取表单数据 请自行修改接口
        this.getRequest("/register/getByPage", this.searchForm).then(res => {
          this.loading = false;
          if (res.success) {
            this.data = res.result.records;
            this.total = res.result.total;
          }
        });
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            if (this.modalType === 0) {
              // 添加 避免编辑后传入id等数据 记得删除
              delete this.form.id;
              // this.postRequest("请求地址", this.form).then(res => {
              //   this.submitLoading = false;
              //   if (res.success) {
              //     this.$Message.success("操作成功");
              //     this.getDataList();
              //     this.modalVisible = false;
              //   }
              // });
              // 模拟请求成功
              this.submitLoading = false;
              this.$Message.success("操作成功");
              this.getDataList();
              this.modalVisible = false;
            } else {
              // 编辑
              // this.postRequest("请求地址", this.form).then(res => {
              //   this.submitLoading = false;
              //   if (res.success) {
              //     this.$Message.success("操作成功");
              //     this.getDataList();
              //     this.modalVisible = false;
              //   }
              // });
              // 模拟请求成功
              this.submitLoading = false;
              this.$Message.success("操作成功");
              this.getDataList();
              this.modalVisible = false;
            }
          }
        });
      },
      add() {
        this.modalType = 0;
        this.modalTitle = "添加";
        this.$refs.form.resetFields();
        delete this.form.id;
        this.modalVisible = true;
      },
      edit(v) {
        this.modalType = 1;
        this.modalTitle = "编辑";
        this.$refs.form.resetFields();
        // 转换null为""
        for (let attr in v) {
          if (v[attr] === null) {
            v[attr] = "";
          }
        }
        let str = JSON.stringify(v);
        let data = JSON.parse(str);
        this.form = data;
        this.modalVisible = true;
      },
      remove(v) {
        this.$Modal.confirm({
          title: "确认删除",
          // 记得确认修改此处
          content: "您确认要删除 " + v.name + " ?",
          loading: true,
          onOk: () => {
            // 删除
            // this.deleteRequest("请求地址，如/deleteByIds/" + v.id).then(res => {
            //   this.$Modal.remove();
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //   }
            // });
            // 模拟请求成功
            this.$Message.success("操作成功");
            this.$Modal.remove();
            this.getDataList();
          }
        });
      },
      delAll() {
        if (this.selectCount <= 0) {
          this.$Message.warning("您还未选择要删除的数据");
          return;
        }
        this.$Modal.confirm({
          title: "确认删除",
          content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
          loading: true,
          onOk: () => {
            let ids = "";
            this.selectList.forEach(function (e) {
              ids += e.id + ",";
            });
            ids = ids.substring(0, ids.length - 1);
            // 批量删除
            // this.deleteRequest("请求地址，如/deleteByIds/" + ids).then(res => {
            //   this.$Modal.remove();
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.clearSelectAll();
            //     this.getDataList();
            //   }
            // });
            // 模拟请求成功
            this.$Message.success("操作成功");
            this.$Modal.remove();
            this.clearSelectAll();
            this.getDataList();
          }
        });
      },
      auditRealName(register){
        this.getRequest('/registerPowerUser/getMainPo', {registerId: register.id}).then(res => {
          if(res.success){
            this.infoForm = res.result;
            this.infoDrawerVisible = true;
          }
          console.log("this.infoForm: ", this.data)
        })
      },
      auditRealNameSubmit(flag){
        if(flag === '0'){
          this.showRejectModal = true;
        }else{
          this.actualSubmit({
            poId: this.infoForm.id,
            auditSuccess: "1"
          });
        }
      },
      rejectSubmit(){
        this.showRejectModal = false;
        this.actualSubmit({
          poId: this.infoForm.id,
          auditSuccess: "0",
          auditMsg: this.auditMsg
        });
      },
      actualSubmit(data){
        this.postRequest('/registerRealnameAudit/realNameAudit', data).then(res => {
          if(res.code == 200){
            this.infoDrawerVisible = false;
            this.getDataList();
          }
        });
      },
      auditPowerUser(){
        this.postRequest('/registerPowerUser/insertOrUpdate', this.infoForm).then(res => {
          if(res.code == 200){
            this.$Message.success("修改成功");
          }else{
            this.$Message.error("修改失败");
          }
        });
      },
      showPic(e){
        const dom = e.target;
        console.log(`url is`, dom.src)
        this.infoForm.avatar = dom.src;
        this.picVisible = true;
      },
      gift(register){
        //查询VIP套餐
        this.getRequest('/registerVipConfig/findListForGift', {accountScope: register.accountType}).then(res => {
          if(res.code == 200){
            this.giftForm = register;
            this.giftForm.gift = res.result;
            this.giftVisible = true;
          }
        });
      },
      giftSubmit(){
        console.log(this.giftForm);
        this.postRequest('/registerVipMemberApplication/giftVip', {registerId: this.giftForm.id, subBizType: this.giftForm.gift}).then(res => {
          if(res.code == 200){
            this.giftVisible = false;
            this.getDataList();
          }
        })
      },
      giftRedenvelope(register){
        this.giftRedenvelopeForm = register;
        this.giftRedenvelopeForm.amount = 0;
        this.giftRedenvelopeVisible = true;
      },
      giftRedenvelopeSubmit(){
        console.log(this.giftRedenvelopeForm);
        this.postRequest('/registerRedEnvelope/giftRedEnvelope', {registerId: this.giftRedenvelopeForm.id, amount: this.giftRedenvelopeForm.amount}).then(res => {
          if(res.code == 200){
            this.giftRedenvelopeVisible = false;
            this.getDataList();
          }
        })
      }
    },
    mounted() {
      this.init();
    }
  };
</script>
<style lang="less">
  .search {
    .operation {
      margin-bottom: 2vh;
    }
    .select-count {
      font-size: 13px;
      font-weight: 600;
      color: #40a9ff;
    }
    .select-clear {
      margin-left: 10px;
    }
    .page {
      margin-top: 2vh;
    }
    .drop-down {
      font-size: 13px;
      margin-left: 5px;
    }
  }
</style>